import { z } from 'zod';
import { DocumentType, InvoiceStatus, PaymentMethod } from '../enums.js';
import { paginationQuerySchema } from '../pagination.js';
import { optionalString, optionalId } from './common.js';
export const invoiceLineSchema = z.object({
    label: z.string().trim().min(1, 'Libellé requis').max(200),
    quantity: z.coerce.number().positive().max(100000).default(1),
    unitPriceCents: z.coerce.number().int().min(0),
    taxRate: z.coerce.number().min(0).max(100).default(0),
    discountCents: z.coerce.number().int().min(0).default(0),
});
export const createInvoiceSchema = z.object({
    type: z.nativeEnum(DocumentType).default(DocumentType.INVOICE),
    status: z.nativeEnum(InvoiceStatus).default(InvoiceStatus.DRAFT),
    customerId: optionalId(),
    vehicleId: optionalId(),
    issueDate: z.coerce.date().optional(),
    dueDate: z.coerce.date().optional(),
    currency: z.string().trim().max(8).default('XOF'),
    notes: optionalString(2000),
    lines: z.array(invoiceLineSchema).default([]),
});
export const updateInvoiceSchema = createInvoiceSchema.partial();
export const updateInvoiceStatusSchema = z.object({
    status: z.nativeEnum(InvoiceStatus),
});
export const addPaymentSchema = z.object({
    method: z.nativeEnum(PaymentMethod),
    amountCents: z.coerce.number().int().min(1),
    reference: optionalString(100),
    paidAt: z.coerce.date().optional(),
});
export const invoicesQuerySchema = paginationQuerySchema.extend({
    type: z.nativeEnum(DocumentType).optional(),
    status: z.nativeEnum(InvoiceStatus).optional(),
    customerId: z.string().optional(),
});
//# sourceMappingURL=invoice.js.map